import type { QueryClient } from '@tanstack/react-query'

import { resetBadgeDetail } from '@src/hooks/useBadgeDetail'
import { invalidateContentBadges } from '@src/hooks/useContentBadges'
import {
  type ParentContent,
  type ParentContentTypes,
  getContentDetailsQueryKey,
  invalidateContentDetails,
  invalidateRecentlyWatched,
  patchVideoHistoryInContentQueryState,
} from '@src/utils/query.util'

export interface RefreshAfterWorkoutArgs {
  locale: string
  parentContent?: ParentContent | null
  entityId?: string
  dayId?: string
}

export function refreshAfterWorkoutQueries(
  queryClient: QueryClient,
  { locale, parentContent, entityId, dayId }: RefreshAfterWorkoutArgs
) {
  void invalidateContentBadges(queryClient)
  void invalidateRecentlyWatched(queryClient, locale)
  void resetBadgeDetail(queryClient)

  if (parentContent?.slug) {
    const queryKey = getContentDetailsQueryKey(
      parentContent._type as ParentContentTypes,
      parentContent.slug,
      locale
    )

    if (queryKey.length) {
      if (entityId) {
        queryClient.setQueryData<ParentContent | null>(queryKey, (prev) =>
          patchVideoHistoryInContentQueryState(prev, entityId, dayId)
        )
      }

      void invalidateContentDetails(queryClient, parentContent, locale)
    }
  }
}
